export default [
    {
        path: 'orders',
        name: 'AdminOrders',
        component:  function () { return import('../views/admin/AdminOrders.vue')}
    },
    {
        path: 'users',
        name: 'AdminSettings',
        component:  function () { return import('../views/admin/AdminSettings.vue')}
    },
    {
        path: 'rating',
        name: 'AdminRating',
        component:  function () { return import('../views/admin/AdminRating.vue')}
    },
    
]